<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-form
          id="new-item"
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="changePassword()"
        >
          <v-card>
            <v-card-title>
              <span class="text-h5">Change Password</span>
            </v-card-title>
            <!-- <v-card-text> -->
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" class="pt-2 mb-2">
                  <v-text-field
                    v-model="password_current"
                    label="Current Password"
                    outlined
                    :rules="complexRules"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    hint="At least 6 characters"
                    @click:append="show1 = !show1"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" class="pt-2 mb-2">
                  <v-text-field
                    v-model="password_new"
                    label="New Password"
                    outlined
                    :rules="complexRules"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    hint="At least 6 characters"
                    @click:append="show1 = !show1"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <!-- </v-card-text> -->
            <v-card-actions>
              <v-btn color="green" text @click="back">
                Back to Sign-in
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="clear">
                Clear
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="!dirty"
                type="submit"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import moment from "moment";
import { commonServices } from "../../services/common.services";
import { RESET_PASSWORD } from "@/store/modules/actions.type";

export default {
  data: () => ({
    dialog: false,
    errorMessages: "",
    formHasErrors: false,
    password_current: null,
    user_id: null,
    password_new: null,
    current_date: moment().format("YYYY-MM-DD"),
    menu: false,
    modal: false,
    valid: true,
    show: false,
    show1: false,
    errors: null,
    slug: "slug",
    error: false,
    complexRules: [
      v => (v || "").indexOf(" ") < 0 || "No spaces are allowed",
      v => (v || "").length >= 6 || `A minimum 6 of  characters is allowed`
    ]
  }),
  computed: {},
  watch: {
    dialog(val) {
      //  if (val)
    }
  },
  mounted() {
    //
  },
  created() {
    this.user_id = this.$route.params.user_id;
    //console.log("param from router", this.$route.params);
  },

  methods: {
    dirty() {},

    async changePassword() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (!this.user_id) {
        return;
      }

      const data = {
        user_id: this.user_id,
        password_current: this.password_current,
        data: {
          password: this.password_new,
          password_expiry_date: commonServices.getExpiryDate(this.date, 3),
          first_login: 1
        }
      };
      if (data) {
        this.$store
          .dispatch(RESET_PASSWORD, data)
          .then(res => {
            if (res.data.message.success) {
              this.$noty.success(res.data.message.success);

              this.clear();
              this.back();
            }

            if (res.data.message.error) {
              this.$noty.success(res.data.message.error);
            }
            // console.log("saved", res);
            //   this.close();
          })
          .catch(res => {
            //console.log("error2", res);
            this.$noty.error("an error has occured...", res.error);
            //this.errors = response.data;
          });
      }
      //console.log("items", data);
    },
    close() {
      // this.dialog = false;
      this.clear();
    },
    back() {
      this.$router.push({ path: "/sign-in" });
    },
    clear() {
      this.password_current = null;
      this.password_new = null;
      this.resetForm();
    },
    resetForm() {
      this.errorMessages = [];
      this.formHasErrors = false;
      this.$refs.form.reset();
    }
  }
};
</script>
